<ion-header
  class="ion-no-border"
  [ngClass]="
    (platformService?.isTouchExperience$ | async)
      ? platformService?.platformType === platformService?.platformEnum?.tablet
        ? 'ion-header-modal-tablet'
        : 'ion-header-modal-mobile'
      : 'ion-header-modal-desktop'
  "
>
  <ion-toolbar>
    <ion-buttons
      *ngIf="(platformService?.isTouchExperience$ | async) === false"
      slot="end"
    >
      <ion-button
        id="close-modal-button"
        data-cy="close-modal-icon"
        (click)="dismissModal()"
      >
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content
  [ngClass]="
    (platformService?.isTouchExperience$ | async)
      ? platformService?.platformType === platformService?.platformEnum?.tablet
        ? 'ion-content-modal-tablet'
        : 'ion-content-modal-mobile'
      : 'ion-content-modal-desktop'
  "
>
  <ion-grid class="content">
    <ng-container *ngIf="isSettingUpAutopay; else bankAccount">
      <app-set-up-autopay
        [isMobile]="isMobile"
        [isDesktop]="isDesktop"
        [currentAutopayStep]="currentAutopayStep"
        [selectedCustomers]="selectedCustomers"
        [effectiveDate]="effectiveDate"
        [addBankAccountForm]="addBankAccountForm"
        [selectedBankAccount]="selectedBankAccount"
        [selectedSegment]="selectedSegment"
        [bankAccounts]="bankAccounts"
        [searchText$]="paymentsModalService.searchText$"
        [vmWithCustomers$]="vmWithCustomers$"
        [canModifyForm]="canSave"
        [isBankRoutingValidationOn]="isBankRoutingValidationOn"
        (changeAutopayStepEmit)="changeAutopayStep($event)"
        (isLoadingEmit)="isFormLoading($event)"
        (setSelectedSegmentEmit)="setSelectedSegment($event)"
        (selectCustomersEmit)="selectCustomers($event)"
        (selectBankAccountEmitter)="selectBankAccount($event)"
        (selectEffectiveDateEmitter)="selectEffectiveDate($event)"
        (isConfirmationValidEmit)="setAutopayConfirmation($event)"
      ></app-set-up-autopay>
    </ng-container>
    <ng-template #bankAccount>
      <h3 data-cy="add-bank-account-title-text">
        <ng-container *ngIf="isPrimaryByDefault || canSelectCustomers">{{
          'i18n.payments.addBankAccountModal.bankAccountDetails' | translate
        }}</ng-container>
        <ng-container *ngIf="isEditingAutopay">
          <div class="title-container" [ngClass]="{ touch: !isDesktop }">
            <ng-container *ngTemplateOutlet="viewOnlyWarning"></ng-container>
            {{ 'i18n.payments.addBankAccountModal.editAutopay' | translate }}
          </div>
        </ng-container>
        <ng-container *ngIf="isEditingBankAccount">
          <div class="title-container" [ngClass]="{ touch: !isDesktop }">
            <ng-container *ngTemplateOutlet="viewOnlyWarning"></ng-container>
            {{
              'i18n.payments.addBankAccountModal.editBankAccount' | translate
            }}
          </div>
        </ng-container>
      </h3>

      <ion-row>
        <ion-col class="form-column">
          <app-segments-bank-account
            [showSegments]="showSegments"
            [selectedSegment]="selectedSegment"
            [isPrimaryByDefault]="isPrimaryByDefault"
            [selectedBankAccount]="selectedBankAccount"
            [bankAccounts]="bankAccounts"
            [isDesktop]="isDesktop"
            [addBankAccountForm]="addBankAccountForm"
            [isEditingAutopay]="isEditingAutopay"
            [isEditingBankAccount]="isEditingBankAccount"
            [canSelectCustomers]="canSelectCustomers"
            [selectedCustomers]="selectedCustomers"
            [canModifyForm]="canSave"
            [isBankRoutingValidationOn]="isBankRoutingValidationOn"
            (isLoadingEmit)="isFormLoading($event)"
            (setSelectedSegmentEmit)="setSelectedSegment($event)"
            (selectBankAccountEmitter)="selectBankAccount($event)"
            (submitFormEmitter)="submitBankAccountData()"
          ></app-segments-bank-account>

          <app-agreement-checkbox
            *ngIf="
              !isEditingAutopay &&
              !isEditingBankAccount &&
              selectedSegment === toggleOptions.newAccount
            "
            [agreementCheckboxControl]="
              addBankAccountForm.controls?.agreementCheckbox
            "
            [addBankAccountForm]="addBankAccountForm"
          ></app-agreement-checkbox>
          <div
            *ngIf="isEditingAutopay"
            data-cy="edit-message"
            class="edit-message"
            [innerHTML]="
              'i18n.payments.addBankAccountModal.editAutopayMessage' | translate
            "
          ></div>
        </ion-col>

        <ion-col
          class="customer-column"
          *ngIf="canSelectCustomers && isDesktop"
        >
          <app-customer-selection-payments-touch
            [vm$]="vmWithCustomers$"
            [searchText$]="paymentsModalService.searchText$"
            [title]="'i18n.payments.addBankAccountModal.customers' | translate"
            [isPresentedInFilterModal]="false"
            [selectedCustomers]="selectedCustomers"
            (customersToFilterSelected)="selectCustomers($event)"
          ></app-customer-selection-payments-touch>
        </ion-col>
      </ion-row>
    </ng-template>
  </ion-grid>
</ion-content>

<ion-footer
  class="ion-footer-modal"
  [class.ion-footer-modal-desktop]="
    (platformService?.isTouchExperience$ | async) === false
  "
>
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        id="no-modal-btn"
        data-cy="add-bank-account-modal-cancel-button"
        [ngClass]="
          !isMobile
            ? 'usf-outline-green-dsktp-tblt-modal-button'
            : 'usf-outline-green-mobile-modal-button'
        "
        (click)="
          shouldShowBackAutopayStepButton
            ? changeAutopayStep(currentAutopayStep - 1)
            : dismissModal()
        "
      >
        {{
          (shouldShowBackAutopayStepButton
            ? 'i18n.common.back'
            : 'i18n.common.cancel'
          ) | translate
        }}
      </ion-button>

      <ion-button
        *ngIf="
          isSettingUpAutopay &&
            currentAutopayStep !== autopaySteps.confirmAutopayDetails;
          else saveButton
        "
        [disabled]="disableAutopayNextButton"
        form="ngForm"
        [type]="
          currentAutopayStep === autopaySteps.stepOne &&
          selectedSegment === toggleOptions.newAccount
            ? 'submit'
            : 'button'
        "
        (click)="changeAutopayStep(currentAutopayStep + 1, true)"
        id="next-modal-btn"
        data-cy="setup-autopay-modal-next-button"
        [ngClass]="
          !isMobile
            ? 'usf-fill-green-dsktp-tblt-modal-button'
            : 'usf-fill-green-mobile-modal-button'
        "
      >
        <ng-container *ngIf="!isLoading">{{
          'i18n.common.next' | translate
        }}</ng-container>
        <ion-spinner
          *ngIf="isLoading"
          name="circles"
          data-cy="loading-spinner-icon"
        ></ion-spinner>
      </ion-button>

      <ng-template #saveButton>
        <ion-button
          form="ngForm"
          [type]="
            selectedSegment === toggleOptions.newAccount ? 'submit' : 'button'
          "
          [disabled]="isSaveDisabled"
          (click)="
            currentAutopayStep === autopaySteps.confirmAutopayDetails
              ? submitAutopayData()
              : submitSelectedBankAccountData()
          "
          id="save-modal-btn"
          data-cy="add-bank-account-modal-save-button"
          [ngClass]="
            !isMobile
              ? 'usf-fill-green-dsktp-tblt-modal-button'
              : 'usf-fill-green-mobile-modal-button'
          "
        >
          <ng-container *ngIf="!isLoading">{{
            (currentAutopayStep === autopaySteps.confirmAutopayDetails
              ? 'i18n.common.submit'
              : 'i18n.common.save'
            ) | translate
          }}</ng-container>
          <ion-spinner
            *ngIf="isLoading"
            name="circles"
            data-cy="loading-spinner-icon"
          ></ion-spinner>
        </ion-button>
      </ng-template>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>

<ng-template #viewOnlyWarning>
  <div
    *ngIf="!canSave"
    class="view-only-header"
    [ngClass]="{ touch: !isDesktop }"
  >
    <img
      src="../../../../../assets/images/alert-orange.svg"
      class="alert-icon"
      data-cy="app-error-image"
      [ngClass]="{ touch: !isDesktop }"
      alt="alert icon"
    />
    <div class="alert-text" [ngClass]="{ touch: !isDesktop, tablet: isTablet }">
      <h2 class="view-only-title">
        {{ 'i18n.payments.addBankAccountModal.viewOnlyTitle' | translate }}
      </h2>
      <p class="view-only-subtitle">
        {{ 'i18n.payments.addBankAccountModal.viewOnlySubtitle' | translate }}
      </p>
    </div>
  </div>
</ng-template>
